import * as React from 'react';
import Button from 'src/components/controls/forms/redesign/FormButton';
import PropertyUtil from 'src/util/PropertyUtil';
import PhoneNumberType from 'src/models/PhoneNumberType';
import { FieldArray } from 'react-final-form-arrays';
import { FormErrors } from 'src/util/FormErrors';
import PhoneNumber from 'src/models/PhoneNumber';
import FormRow from 'src/components/controls/forms/FormRow';
import FormCheckbox from 'src/components/controls/forms/redesign/FormCheckbox';
import FormTextBox, { FormTextBoxDataType } from 'src/components/controls/forms/redesign/FormTextbox';
import { FormApi, FieldState } from 'final-form';
import { AnyObject } from 'react-final-form';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import { SelectItem } from 'src/models/common/SelectItem';

export interface IMultiplePhoneNumberProps {
    phoneNumberTypes?: Array<PhoneNumberType>;
    form?: FormApi;
    baseFieldName: string;
}

type IMultiplePhoneNumberAllProps = IMultiplePhoneNumberProps;

class MultiplePhoneNumber extends React.Component<IMultiplePhoneNumberAllProps> {
    constructor(props: IMultiplePhoneNumberAllProps) {
        super(props);
    }

    componentWillUnmount() {
        this.props.form?.reset();
    }
    validatePhoneNumbers = (phoneNumberList: AnyObject) => {
        let errorList: Array<FormErrors<PhoneNumber>> = [];

        const isPhoneNumberEmpty = (index: number) =>
            phoneNumberList[index] === undefined || phoneNumberList[index].number === undefined || phoneNumberList[index].number === '';

        const isPhoneNumberExtensionNotNumeric = (index: number) =>
            phoneNumberList[index] && phoneNumberList[index].extension && !phoneNumberList[index].extension.toString().match(/^[0-9]*$/);
        const isPhoneNumberExtensionNotEmpty = (index: number) =>
            phoneNumberList[index] && !(phoneNumberList[index].extension === undefined || phoneNumberList[index].extension === '');
        const isPhoneNumberExtensionTooLong = (index: number) =>
            phoneNumberList[index] && phoneNumberList[index].extension && phoneNumberList[index].extension.toString().length > 10;

        if (!phoneNumberList || phoneNumberList.length === 0) {
            return undefined;
        }
        for (let i = 0; i < phoneNumberList?.length; i++) {
            const errors: FormErrors<PhoneNumber> = {};

            if (isPhoneNumberEmpty(i)) {
                errors.number = 'Phone number required';
            }

            if (isPhoneNumberExtensionNotNumeric(i) && isPhoneNumberExtensionNotEmpty(i)) {
                errors.extension = 'Digits only for extension';
            }

            if (isPhoneNumberExtensionTooLong(i)) {
                errors.extension = 'Max of 10 digits for extension';
            }
            if (Object.keys(errors).length) {
                errorList = [];
                errorList[i] = errors;
            } else {
                errorList = undefined;
            }
        }
        return errorList;
    };
    // Add array handlers
    handlePrimaryPhoneNumberAddsChange = (form: FormApi, index: number) => {
        const addRecords: Array<PhoneNumber> = (form.getState().values[this.props.baseFieldName] as AnyObject)?.phoneNumberChanges.phoneNumberAdds;
        let oldRecords: Array<PhoneNumber> = (form.getState().values[this.props.baseFieldName] as AnyObject)?.phoneNumberChanges.phoneNumbers;
        const updatedRecords: Array<PhoneNumber> = (this.props.form?.getState().values[this.props.baseFieldName] as AnyObject)?.phoneNumberChanges
            .phoneNumberUpdates;

        if (addRecords?.length) {
            for (let i = 0; i < addRecords?.length; i++) {
                form.change(`${this.props.baseFieldName}.phoneNumberChanges.phoneNumberAdds[${i}].isPrimary`, i === index);
            }
            for (let i = 0; i < oldRecords?.length; i++) {
                form.change(`${this.props.baseFieldName}.phoneNumberChanges.phoneNumbers[${i}].isPrimary`, false);
            }
            for (let i = 0; i < updatedRecords?.length; i++) {
                this.props.form?.change(`${this.props.baseFieldName}.phoneNumberChanges.phoneNumberUpdates[${i}].isPrimary`, false);
            }
        }

        // prepare updated payload after finding which one was turned off/on
        // update for payload array
        oldRecords = (form.getState().values[this.props.baseFieldName] as AnyObject)?.phoneNumberChanges.phoneNumbers;

        for (let i = 0; i < oldRecords?.length; i++) {
            const phoneNumber: PhoneNumber = oldRecords[i];
            if (updatedRecords && updatedRecords.some((x) => x.id === phoneNumber?.id)) {
                const prevUpdated = oldRecords.find((x) => x.id === phoneNumber.id);
                const prevUpdatedIndex = updatedRecords.findIndex((x) => x.id === phoneNumber.id);
                this.props.form?.mutators.update(`${this.props.baseFieldName}.phoneNumberChanges.phoneNumberUpdates`, prevUpdatedIndex, prevUpdated);
            } else {
                this.props.form?.mutators.push(`${this.props.baseFieldName}.phoneNumberChanges.phoneNumberUpdates`, phoneNumber);
            }
        }
    };

    handlePhoneNumberTypeAddsChange = (form: FormApi, index: number, phoneNumberTypeOffice: string) => {
        // tslint:disable-next-line:no-string-literal
        if (
            PropertyUtil.SafeGet(
                () =>
                    (form.getState().values[this.props.baseFieldName] as AnyObject).phoneNumberChanges.phoneNumberAdds[index].typeId.toString() !==
                    phoneNumberTypeOffice
            )
        ) {
            form.change(`${this.props.baseFieldName}.phoneNumberChanges.phoneNumberAdds[${index}].extension`, undefined);
        }

        this.handlePhoneNumberAddsChange(index);
    };

    handlePhoneNumberAddsRemove = (form: FormApi, index: number, fields: { remove: (index: number) => AnyObject } & FieldState<AnyObject>) => {
        // tslint:disable-next-line:no-string-literal
        fields.remove(index);
    };

    // Read-Only handlers
    handlePrimaryPhoneNumberChange = (form: FormApi, index: number) => {
        let records: Array<PhoneNumber> = (this.props.form?.getState().values[this.props.baseFieldName] as AnyObject)?.phoneNumberChanges.phoneNumbers;
        const updatedRecords: Array<PhoneNumber> = (this.props.form?.getState().values[this.props.baseFieldName] as AnyObject)?.phoneNumberChanges
            .phoneNumberUpdates;
        const addedRecords: Array<PhoneNumber> = (this.props.form?.getState().values[this.props.baseFieldName] as AnyObject)?.phoneNumberChanges
            .phoneNumberAdds;

        if (records) {
            // set visual change on dirty form and clear old values for payload array
            for (let i = 0; i < records?.length; i++) {
                this.props.form?.change(`${this.props.baseFieldName}.phoneNumberChanges.phoneNumbers[${i}].isPrimary`, i === index);
            }
            for (let i = 0; i < updatedRecords?.length; i++) {
                this.props.form?.change(`${this.props.baseFieldName}.phoneNumberChanges.phoneNumberUpdates[${i}].isPrimary`, false);
            }
            for (let i = 0; i < addedRecords?.length; i++) {
                this.props.form?.change(`${this.props.baseFieldName}.phoneNumberChanges.phoneNumberAdds[${i}].isPrimary`, false);
            }

            // overwrite or add to updates array
            records = (this.props.form?.getState().values[this.props.baseFieldName] as AnyObject)?.phoneNumberChanges.phoneNumbers;

            for (let i = 0; i < records?.length; i++) {
                const phoneNumber: PhoneNumber = records[i];
                if (updatedRecords && updatedRecords.some((x) => x.id === phoneNumber?.id)) {
                    const prevUpdated = records.find((x) => x.id === phoneNumber.id);
                    const prevUpdatedIndex = updatedRecords.findIndex((x) => x.id === phoneNumber.id);
                    this.props.form?.mutators.update(
                        `${this.props.baseFieldName}.phoneNumberChanges.phoneNumberUpdates`,
                        prevUpdatedIndex,
                        prevUpdated
                    );
                } else {
                    this.props.form?.mutators.push(`${this.props.baseFieldName}.phoneNumberChanges.phoneNumberUpdates`, phoneNumber);
                }
            }
        }
    };

    handlePhoneNumberTypeChange = (form: FormApi, index: number, phoneNumberTypeOffice: string) => {
        // clear out ext for non-office numbers
        // tslint:disable-next-line:no-string-literal
        if (
            PropertyUtil.SafeGet(
                () =>
                    (form.getState().values[this.props.baseFieldName] as AnyObject).phoneNumberChanges.phoneNumbers[index].typeId.toString() !==
                    phoneNumberTypeOffice
            )
        ) {
            form.change(`${this.props.baseFieldName}.phoneNumberChanges.phoneNumbers[${index}].extension`, undefined);
        }
        this.handlePhoneNumberChange(index);
    };

    handlePhoneNumberChange = (index: number) => {
        // find and update
        const records: Array<PhoneNumber> = (this.props.form?.getState().values[this.props.baseFieldName] as AnyObject)?.phoneNumberChanges
            .phoneNumbers;
        const updatedRecords: Array<PhoneNumber> = (this.props.form?.getState().values[this.props.baseFieldName] as AnyObject)?.phoneNumberChanges
            .phoneNumberUpdates;

        for (let i = 0; i < records?.length; i++) {
            const phoneNumber: PhoneNumber = records[i];
            console.log(index);
            if (i === index) {
                if (updatedRecords && updatedRecords.some((x) => x.id === phoneNumber?.id)) {
                    const prevUpdated = records.find((x) => x.id === phoneNumber.id);
                    const prevUpdatedIndex = updatedRecords.findIndex((x) => x.id === phoneNumber.id);
                    this.props.form?.mutators.update(
                        `${this.props.baseFieldName}.phoneNumberChanges.phoneNumberUpdates`,
                        prevUpdatedIndex,
                        prevUpdated
                    );
                } else {
                    this.props.form?.mutators.push(`${this.props.baseFieldName}.phoneNumberChanges.phoneNumberUpdates`, phoneNumber);
                }
            }
        }
    };

    handlePhoneNumberAddsChange = (index: number) => {
        // find and update
        const addedRecords: Array<PhoneNumber> = (this.props.form?.getState().values[this.props.baseFieldName] as AnyObject)?.phoneNumberChanges
            .phoneNumberAdds;
        const updatedRecords: Array<PhoneNumber> = (this.props.form?.getState().values[this.props.baseFieldName] as AnyObject)?.phoneNumberChanges
            .phoneNumberUpdates;

        for (let i = 0; i < addedRecords?.length; i++) {
            const phoneNumber: PhoneNumber = addedRecords[i];
            console.log(index);
            if (i === index) {
                if (updatedRecords && updatedRecords.some((x) => x.id === phoneNumber?.id)) {
                    const prevUpdated = addedRecords.find((x) => x.id === phoneNumber.id);
                    const prevUpdatedIndex = updatedRecords.findIndex((x) => x.id === phoneNumber.id);
                    this.props.form?.mutators.update(
                        `${this.props.baseFieldName}.phoneNumberChanges.phoneNumberUpdates`,
                        prevUpdatedIndex,
                        prevUpdated
                    );
                } else {
                    this.props.form?.mutators.push(`${this.props.baseFieldName}.phoneNumberChanges.phoneNumberUpdates`, phoneNumber);
                }
            }
        }
    };

    handlePhoneNumberRemove = (form: FormApi, index: number, fields: { remove: (index: number) => AnyObject } & FieldState<AnyObject>) => {
        // tslint:disable-next-line:no-string-literal
        const toDelete = PropertyUtil.SafeGet(
            () => (form.getState().values[this.props.baseFieldName] as AnyObject).phoneNumberChanges.phoneNumbers[index]
        );
        const updatedRecords = PropertyUtil.SafeGet(
            () => (form.getState().values[this.props.baseFieldName] as AnyObject).phoneNumberChanges.phoneNumberUpdates
        );
        if (toDelete !== undefined) {
            this.props.form?.mutators.push(`${this.props.baseFieldName}.phoneNumberChanges.phoneNumberDeletes`, toDelete);
            fields.remove(index);
        }
        if (toDelete !== undefined && updatedRecords?.some((x: PhoneNumber) => x.id === toDelete.id)) {
            const prevUpdatedIndex = updatedRecords.findIndex((x: PhoneNumber) => x.id === toDelete.id);
            this.props.form?.mutators.remove(`${this.props.baseFieldName}.phoneNumberChanges.phoneNumberUpdates`, prevUpdatedIndex);
        }
    };

    public render() {
        const phoneNumberTypes = PropertyUtil.SafeGet(() => this.props.phoneNumberTypes);
        const phoneNumberTypeOffice = PropertyUtil.SafeGet(() =>
            phoneNumberTypes.find((phoneNumbertype: PhoneNumberType) => phoneNumbertype.type === 'Office').id.toString()
        );
        const selectPhoneNumberTypes = phoneNumberTypes
            ? phoneNumberTypes.map((phoneNumberType: PhoneNumberType) => new SelectItem(phoneNumberType.id, phoneNumberType.type))
            : undefined;
        return (
            <>
                <div className="ownership-phone-div">
                    <div>
                        <FieldArray name={`${this.props.baseFieldName}.phoneNumberChanges.phoneNumbers`} validate={this.validatePhoneNumbers}>
                            {({ fields, meta }) =>
                                fields.map((name, index) => (
                                    <div key={name} style={{height: '6rem', marginLeft: '.5rem'}}>
                                        <FormRow>
                                            <FormCheckbox
                                                name={`${name}.isPrimary`}
                                                label="Primary"
                                                onChange={() => this.handlePrimaryPhoneNumberChange(this.props.form, index)}
                                                style={{marginTop: '2rem'}}
                                            />
                                            <FormTextBox
                                                name={`${name}.number`}
                                                label="Number"
                                                type={FormTextBoxDataType.PhoneNumber}
                                                isRequired={true}
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handlePhoneNumberChange(index)}
                                            />
                                            {/* Conditional rendering of Phone Number Extension Field if Phone Number Type is Office*/}
                                            {/* tslint:disable-next-line: max-line-length */}
                                            {PropertyUtil.SafeGet(
                                                () =>
                                                    (
                                                        this.props.form?.getState().values[this.props.baseFieldName] as AnyObject
                                                    ).phoneNumberChanges.phoneNumbers[index].typeId.toString() === phoneNumberTypeOffice
                                            ) && (
                                                <FormTextBox
                                                    name={`${name}.extension`}
                                                    label="Ext."
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handlePhoneNumberChange(index)}
                                                />
                                            )}
                                            <FormSelect
                                                name={`${name}.typeId`}
                                                label="Phone Type"
                                                items={selectPhoneNumberTypes}
                                                onChange={() => this.handlePhoneNumberTypeChange(this.props.form, index, phoneNumberTypeOffice)}
                                            />
                                            {/* tslint:disable-next-line: max-line-length */}
                                            <span
                                                className="remove-phone"
                                                onClick={() => this.handlePhoneNumberRemove(this.props.form, index, fields)}
                                                style={{ cursor: 'pointer', marginTop: '2.5rem' }}
                                            >
                                                ❌
                                            </span>
                                        </FormRow>
                                    </div>
                                ))
                            }
                        </FieldArray>
                        <FieldArray name={`${this.props.baseFieldName}.phoneNumberChanges.phoneNumberAdds`} validate={this.validatePhoneNumbers}>
                            {({ fields, meta }) =>
                                fields.map((name, index) => (
                                    <div key={name} style={{marginLeft: '.5rem', height: '6rem'}}>
                                        <FormRow>
                                            <FormCheckbox
                                                name={`${name}.isPrimary`}
                                                label="Primary"
                                                onChange={() => this.handlePrimaryPhoneNumberAddsChange(this.props.form, index)}
                                                style={{marginTop: '2rem'}}
                                            />
                                            <FormTextBox
                                                name={`${name}.number`}
                                                label="Number"
                                                type={FormTextBoxDataType.PhoneNumber}
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handlePhoneNumberAddsChange(index)}
                                                isRequired={true}
                                            />
                                            {/* Conditional rendering of Phone Number Extension Field if Phone Number Type is Office*/}
                                            {/* tslint:disable-next-line: max-line-length */}
                                            {PropertyUtil.SafeGet(
                                                () =>
                                                    (
                                                        this.props.form?.getState().values[this.props.baseFieldName] as AnyObject
                                                    ).phoneNumberChanges.phoneNumberAdds[index].typeId.toString() === phoneNumberTypeOffice
                                            ) && (
                                                <FormTextBox
                                                    name={`${name}.extension`}
                                                    label="Ext."
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handlePhoneNumberAddsChange(index)}
                                                />
                                            )}
                                            <FormSelect
                                                name={`${name}.typeId`}
                                                label="Phone Type"
                                                items={selectPhoneNumberTypes}
                                                onChange={() => this.handlePhoneNumberTypeAddsChange(this.props.form, index, phoneNumberTypeOffice)}
                                            />
                                            {/* tslint:disable-next-line: max-line-length */}
                                            <span
                                                className="remove-phone"
                                                onClick={() => this.handlePhoneNumberAddsRemove(this.props.form, index, fields)}
                                                style={{ cursor: 'pointer', marginTop: '2.5rem' }}
                                            >
                                                ❌
                                            </span>
                                        </FormRow>
                                    </div>
                                ))
                            }
                        </FieldArray>
                    </div>
                    {/*tslint:disable-next-line:max-line-length*/}
                    <Button
                        className="blue-hover-button"
                        onClick={() => this.props.form?.mutators.push(`${this.props.baseFieldName}.phoneNumberChanges.phoneNumberAdds`)}
                        text="Add Phone Number"
                        intent="success"
                        style={{marginTop: '3rem'}}
                    />
                </div>
            </>
        );
    }
}

export default MultiplePhoneNumber;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/MultiplePhoneNumber.tsx